module.exports = __webpack_public_path__ + "static/history02-43732a63a21b987d0531e0f46ae7acba.png";